import React, { useMemo } from 'react';
import { Breadcrumb } from 'antd';
import { useGlobalContext, useStaffContext } from 'store';
import Icon from 'component/icon';

const BreadCrumb = (props) => {
    const { path } = props;
    const { isMobileView } = useGlobalContext();
    const { pages } = useStaffContext();

    const page = useMemo(() => {
        const findPage = (list) => {
            let result;
            for (let i = 0; i < list.length; i += 1) {
                if (list[i].children?.length) {
                    result = findPage(list[i].children, path);
                } else if (list[i].path === path) {
                    result = list[i];
                }
                if (result) {
                    break;
                }
            }
            return result;
        };
        const currPath = findPage(pages);
        return currPath?.name;
    }, [pages, path]);

    return (
        <Breadcrumb className="font-boldr">
            {!isMobileView && (
                <>
                    <Breadcrumb.Item>
                        <Icon name="home" size={24} />
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>{pages[0].name}</Breadcrumb.Item>
                </>
            )}
            <Breadcrumb.Item>{page}</Breadcrumb.Item>
        </Breadcrumb>
    );
};

export default BreadCrumb;
